export default "__VITE_ASSET__Dhiz_6LL__"